import { generate, type ToVariants } from '@/components/experiments/Core/generateBasicExperimentComponent';

// ?preferred_variant=APPLE_QUALITY_TV_EXP:control
// ?preferred_variant=APPLE_QUALITY_TV_EXP:variant_1
// ?remove_preferred_experiment=APPLE_QUALITY_TV_EXP

export const AppleQualityTvExpName = 'APPLE_QUALITY_TV_EXP' as const;

export type AppleQualityTvExpVariants = ToVariants<typeof AppleQualityTvExpVariants>;

export const AppleQualityTvExpVariants = {
	/** free trial feature same as on prod */
	CONTROL: 'control',
	/** V1: High rated title suggestions in buybox (all filter states) */
	VARIANT_1: 'variant_1',
} as const;

export default generate(AppleQualityTvExpName, AppleQualityTvExpVariants);
